import React from 'react';
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";
import {AddressFormatter, DateFormatter} from "../../../utils/formatters";

class RoyaltyPaymentList extends React.Component {

    refresh = () => {
        this.list && this.list.refresh();
    }

    refreshBackground = () => {
        this.list && this.list.refreshBackground();
    }

    render() {
        const filterable = true;
        const sortable = true;
        const {view, componentConfig, filter, selection, isLoading} = this.props;
        const props = {componentConfig, filter, loading: isLoading, pageSize: 5, formId: this.props.formId};
        if (view) {
            props.view = view;
        }
        return (
            <SelectorGrid
                ref={(el) => this.list = el}
                gridid={this.props.gridid !== undefined ? this.props.gridid : componentConfig.componentname + "List"}
                {...props}
                columns={{
                    [componentConfig.idfield]: {
                        header: 'Kód',
                        width: 1,
                        sortable,
                        filterable,
                    },
                    "licensor.name": {
                        header: 'Jogtulajdonos',
                        width: 5,
                        sortable,
                        filterable,
                    },
                    "licensee.name": {
                        header: 'Jogosult',
                        width: 5,
                        sortable,
                        filterable,
                    },
                    "payment_date": {
                        header: 'Dátum',
                        width: 1,
                        sortable,
                        filterable,
                        renderer: DateFormatter
                    }
                }}
                orderBy={{field: componentConfig.idfield, direction: "DESC"}}
                selection={selection}
                onSelectionChange={(selection) => this.props.loadForm(selection.value)}
            />
        );
    }
}

export default RoyaltyPaymentList;
